import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, userIdentityShape, ugcAgeSuitabilityShape } from '@bibliocommons/bc-prop-types';

import shelfItemShape from 'app/shapes/shelves/shelfItemShape';
import AgeSuitabilityDisplay from '../../../shared/UGC/AgeSuitabilityDisplay';

export default class ShelfListItemAgeSuitabilityInfo extends React.PureComponent {
  render() {
    const {
      bib,
      item,
      owner,
      ownerAgeSuitabilityForBib,
      ageSuitabilitiesTransactions,
      ageSuitabilitiesActions,
      shelfTransactions,
      shelfActions
    } = this.props;

    if (ownerAgeSuitabilityForBib) {
      return (
        <div className="cp-shelf-list-item-age-suitability-info">
          <AgeSuitabilityDisplay
            bib={bib}
            item={item}
            owner={owner}
            age={ownerAgeSuitabilityForBib}
            ageSuitabilitiesTransactions={ageSuitabilitiesTransactions}
            ageSuitabilitiesActions={ageSuitabilitiesActions}
            shelfTransactions={shelfTransactions}
            shelfActions={shelfActions}
          />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemAgeSuitabilityInfo.propTypes = {
  bib: bibShape.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerAgeSuitabilityForBib: ugcAgeSuitabilityShape,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired
};
